module.exports = __webpack_public_path__ + "static/media/crop.0c6f329b.png";